import { render, staticRenderFns } from "./BuyingStation.vue?vue&type=template&id=1c7cd69e&scoped=true"
import script from "./BuyingStation.vue?vue&type=script&lang=js"
export * from "./BuyingStation.vue?vue&type=script&lang=js"
import style0 from "./BuyingStation.vue?vue&type=style&index=0&id=1c7cd69e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7cd69e",
  null
  
)

export default component.exports